import Music from "@components/Collection/artist/music";
import { useLocalSearchParams } from "expo-router";

const ArtistMusicPage = () => {
  const { artistId } = useLocalSearchParams<{ artistId: string }>();
  return <Music artistId={artistId} />;
};

export default ArtistMusicPage;
